export enum EventType {
  TRAINING = 'TRAINING',
  MATCH = 'MATCH',
  BIRTH_DATE = 'BIRTH_DATE',
  ONE_TIME_EVENT = 'ONE_TIME_EVENT',
}
